import { useEffect } from "react";
import {
  Block1,
  Block2,
  ContainerCenter,
  ContainerCenterInside,
  Line1,
  Line2,
  MainContainer,
  TopDiv,
} from "./styles";
import GlobalStyle from "../../styles/globalStyles";
import TopBar from "../../components/general/TopBar";
import BestWorkers from "./BestWorkers";
import DeDList from "./DeDList"; // Drag and drop List
import { useSelector, useDispatch } from "react-redux";

import {
  fetchDashboardFlows,
  fetchDashboardUsers,
  fetchDashboardTasks,
  fetchDashboardChat,
} from "../../state/dashboard/actions";
import Menu from "../../components/general/Menu";
import Productivity from "./Productivity";

const DashboardPage = () => {
  const dispatch = useDispatch();

  const dashUsers = useSelector((state) => state.dashboard.usersProductivity);
  const dashTasks = useSelector((state) => state.dashboard.tasksProductivity);
  const dashFlows = useSelector((state) => state.dashboard.flowsProductivity);
  const dashChat = useSelector((state) => state.dashboard.chatProductivity);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = () => {
    if (dashUsers.status !== "succeeded") {
      dispatch(fetchDashboardUsers());
    }

    if (dashTasks.status !== "succeeded") {
      dispatch(fetchDashboardTasks());
    }

    if (dashFlows.status !== "succeeded") {
      dispatch(fetchDashboardFlows());
    }

    if (dashChat.status !== "succeeded") {
      dispatch(fetchDashboardChat());
    }
  };

  return (
    <TopDiv>
      <GlobalStyle />
      <Menu />
      <MainContainer>
        <TopBar text="Dashboard" />
        <ContainerCenter>
          <ContainerCenterInside>
            <Block1>
              <DeDList />
            </Block1>
            <Block2>
              <Line1 isDisabled={false}>
                <BestWorkers dashUsers={dashUsers} />
              </Line1>
              <Line2 isDisabled={false}>
                <Productivity dashTasks={dashTasks} />
              </Line2>
            </Block2>
          </ContainerCenterInside>
        </ContainerCenter>
      </MainContainer>
    </TopDiv>
  );
};

export default DashboardPage;
